import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import { CustomArrowProps } from 'react-slick';

type Props = CustomArrowProps & {
  arrowType: 'prev' | 'next';
  prevBtnStyle?: string;
  nextBtnStyle?: string;
  prevArrowStyle?: string;
  nextArrowStyle?: string;
};

const NavigationArrow: React.FC<Props> = ({
  onClick,
  arrowType,
  className,
  prevBtnStyle,
  nextBtnStyle,
  prevArrowStyle,
  nextArrowStyle,
}) => {
  if (arrowType === 'prev') {
    return (
      <button
        type="button"
        className={`${className?.includes('slick-disabled') ? 'hidden' : prevBtnStyle}`}
        onClick={onClick}
      >
        <BsChevronLeft className={prevArrowStyle} />
      </button>
    );
  }

  return (
    <button
      type="button"
      className={`${className?.includes('slick-disabled') ? 'hidden' : nextBtnStyle}`}
      onClick={onClick}
    >
      <BsChevronRight className={nextArrowStyle} />
    </button>
  );
};

export default NavigationArrow;
